import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PartnerWallet} from '../../../dto/partnerWallet';

@Component({
  selector: 'app-edit-wallet-dialog',
  templateUrl: './edit-wallet-dialog.component.html',
  styleUrls: ['./edit-wallet-dialog.component.css']
})
export class EditWalletDialogComponent implements OnInit {
  public title = 'Edit Wallet';
  public text = 'Update Wallet';


  public isClosed: boolean;
  public customName: string;
  public currencyCode: number;
  public loadFee: number;

  public walletIban: string|null;
  public walletBic: string|null;
  public revolutAccountId: string|null;
  public senderFilter: string|null;
  public notificationEmail: string|null;

  public brandReferralCode: string|null;
  public brandReferralURLHintText: string|null;
  public brandReferralUrlLink: string|null;

  constructor(
    public dialogRef: MatDialogRef<EditWalletDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PartnerWallet
  ) { }

  ngOnInit() {

    if (this.data != null) {
      this.customName = this.data.customName;
      this.walletIban = this.data.walletIban;
      this.notificationEmail = this.data.notificationEmail;
      this.walletBic = this.data.walletBic;
      this.senderFilter = this.data.senderFilter;
      this.revolutAccountId = this.data.revolutAccountId;
      this.isClosed = this.data.isClosed;
      this.loadFee = this.data.loadFee;

      this.brandReferralCode = this.data.brandReferralCode;
      this.brandReferralURLHintText = '( ' + location.origin + '/brand/' + this.data.brandReferralCode + ' )';
      this.brandReferralUrlLink = `/brand/${this.data.brandReferralCode}`;

    }
  }

  onYesClick(): void {

    const model = new PartnerWallet();
    model.customName = this.customName;
    model.notificationEmail = this.notificationEmail;
    model.walletIban = this.walletIban;
    model.walletBic = this.walletBic;
    model.revolutAccountId = this.revolutAccountId;
    model.senderFilter = this.senderFilter;
    model.isClosed = this.isClosed;
    model.loadFee = this.loadFee;
    model.brandReferralCode = this.brandReferralCode;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
